<template>
    <div v-theme="'wide'" id="show-adressen">        
        <h1> Alle Adressen </h1>
        <div>
            <input type="text" v-model="search" placeholder="Adressen durchsuchen ..." />
        </div>
        <div v-for="adresse in filteredAdressen" v-bind:key="adresse.id" class="single-adressen">                                    
            <p>{{ adresse.strasse }} </p>
            <p>{{ adresse.plz }} {{ adresse.ort }}</p>            
        </div>
    </div>
</template>

<script>

import searchMixin from '../../mixins/searchMixin'

export default {
    components: {
    
    },
    created() {
       
    },
    data() {
        return {
            adressen: [],
            search: ''
        }
    },  
    computed: {
        
    },
    methods: {
        
    },
    filters: {
        'to-uppercase': function(value) {
            return value.toUpperCase();
        },
        'limitto': function(value) {
            console.log(typeof value);
            return value.slice(0,100) + ' ... read more';
        }
    },
    directives: {
        'rainbow': {
            bind(el, binding, vnode) {
                el.style.color = "#" + Math.random().toString().slice(2,8);
            }
        }
    },
    mixins: [
        searchMixin
    ]
    
}
</script>

<style scoped>
    #show-adressen{
        max-width: 800px;
        margin: 0 auto;
    }
  
    .single-adressen{
        float: left;
        width: 30%;
        min-height: 150px;
        padding: 20px;
        margin-top: 20px;
        margin-bottom: 20px;
        margin-right: 2%;
        box-sizing: border-box;
        background: #eee;
    }
    
</style>



// WEBPACK FOOTER //
// showAdressen.vue?15055377